import React from "react";
import { Card } from "./components/ui/card";

const TeamPage = () => {
    const teamMembers = [
        {
            name: "Yash Kothari",
            role: "CEO & Co-Founder",
            image: "https://cdn.inika.app/Inika/Yash_Kothari.jpeg?no_cache=1",
            link: "https://www.linkedin.com/in/yash-kothari-5114b31b3/"
        },
        {
            name: "Tarun Karthic",
            role: "CTO & Co-Founder",
            image: "https://cdn.inika.app/Inika/Tarun_Karthic.jpeg?no_cache=1",
            link: "https://www.linkedin.com/in/tarun-karthic/"
        },
        {
            name: "Rithvik Kesani",
            role: "Engineering",
            image: "https://cdn.inika.app/Inika/Rithvik_Kesani.jpeg?no_cache=1",
            link: "https://www.linkedin.com/in/rithvik-kesani001/"
        },
        {
            name: "Rishi Ravichandran",
            role: "Engineering",
            image: "https://cdn.inika.app/Inika/Rishi_Ravichandran.jpeg?no_cache=1",
            link: "https://www.linkedin.com/in/rishiganeshr/"
        },
        {
            name: "Dnyaneshwar Ghule",
            role: "Engineering",
            image: "https://cdn.inika.app/Inika/Dnyaneshwar_Ghule.jpeg?no_cache=1",
            link: "https://www.linkedin.com/in/dnyaneshwar-ghule-364487213/"
        },
        {
            name: "Lyndon Puzon",
            role: "Engineering",
            image: "https://cdn.inika.app/Inika/LyndonPuzon.jpeg?no_cache=1",
            link: "https://www.linkedin.com/in/donpuz/"
        }
    ];

    return (
        <div className="min-h-screen relative overflow-hidden bg-black text-white font-sans">
            {/* Background effects */}
            <div className="fixed inset-0 bg-black -z-50" />
            <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -inset-[10%] bg-gradient-to-br from-purple-500/10 via-blue-500/10 to-teal-500/10 blur-3xl" />
                <div className="absolute -inset-[10%] bg-white/3 blur-3xl" />
            </div>

            <div className="relative pt-20 md:pt-24 pb-12 md:pb-20 px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-8 md:mb-12">
                        Meet Our <span className="text-[hsl(30,100%,85%)] italic">Team</span>
                    </h1>
                    <p className="text-lg text-white/70 max-w-2xl mx-auto mb-10 md:mb-16">

                    </p>
                </div>

                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-12">
                        {teamMembers.map((member) => (
                            <Card
                                key={member.name}
                                className="flex flex-col items-center p-4 md:p-6 bg-white/5 backdrop-blur-sm border border-white/10 transition-all duration-300 hover:cursor-pointer hover:border-white/20 hover:bg-white/10 hover:scale-105 active:scale-95"
                                onClick={() => window.open(member.link, '_blank')}
                            >
                                <div className="w-28 h-28 md:w-40 md:h-40 rounded-full overflow-hidden mb-4 md:mb-6 bg-gradient-to-br from-purple-500/20 to-blue-500/20">
                                    <img
                                        src={member.image}
                                        alt={member.name}
                                        className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                                        onError={(e) => {
                                            e.target.src = "https://via.placeholder.com/150?text=" + member.name.charAt(0);
                                        }}
                                    />
                                </div>
                                <h3 className="text-lg md:text-xl font-semibold text-white mb-1 md:mb-2 text-center">{member.name}</h3>
                                <p className="text-sm md:text-base text-[hsl(30,100%,85%)] text-center">{member.role}</p>
                            </Card>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamPage;
